module.exports = __webpack_public_path__ + "static/media/xmark.966d8579.svg";